import styled, { css } from "styled-components";
import { images } from "../../constants";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: nowrap;
  background-color: var(--secondary);
  min-height: 100vh;
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  /* height: 50rem; */
  justify-content: space-between;
  background-color: var(--darkBlue);
  /* gap: 5rem; */


  @media (max-width: 900px) {
    flex-direction: column;
    height: 40rem;
    justify-content: center;
    align-items: center;
  }
  
`;

export const IconBanner = styled.div`
  display: flex;
  background-color: var(--hardYellow);
  background-image: url(${images.fundobanner}) ;
  background-repeat: repeat;
  margin: 15rem 0 5rem 0;
  width: 79%;
  justify-content: right;
  border-radius: 0 7rem 7rem 0;
  box-shadow: 0.3rem 0.3rem 0.3rem var(--primary);
  
  @media (max-width: 900px) {
    width: 100%;
    border-radius: 0;
    justify-content: center;
    align-items: center;
    /* margin: 10rem 0; */
  }
`;

export const ViewGalery = styled.div`
display: flex;
width: 70rem;
/* padding: 0 0 0 15rem; */
align-items: center;
justify-content: center;
margin-left: 20%;
/* margin: 12rem 0 2rem 0; */
/* padding-right: 2rem; */
/* padding-bottom: 7rem; */

/* height: 40rem; */

  @media (max-width: 1300px) {
    margin: 0;
    width: 50rem;
  }
`;

export const ViewImages = styled.div`
display: flex;
width: 100%;


@media (max-width: 900px) {
  width: 100%;
  }
/* box-shadow: 0.3rem 0.3rem 0.3rem var(--gray); */
`;

export const Title = styled.h1`
  color: var(--secondary);
  font-family: var(--familyTitle);
  font-size: calc(var(--size) * 2);
  padding: 18rem 10rem 10rem 10rem;
  width: 100%;

  @media (max-width: 1095px) {
    font-size: calc(var(--size) * 1.8);
  }

  @media (max-width: 865px) {
    /* padding: 3rem 1rem; */
    font-size: calc(var(--size) * 1.6);
    padding: 2rem;
  }

  @media (max-width: 584px) {
    padding: 1rem;
  }
  @media (max-width: 992px) {
  }
  @media (max-width: 1200px) {
  }

`;

export const ImgBanner = styled.img`
  width: 21rem;
  height:25rem;
  margin: 0 5rem 0 5rem;

  @media (max-width: 1300px) {
    margin: 0 5rem 0 2rem;
    /* width: 50rem; */
  }

  @media (max-width: 900px) {
    width: 19rem;
    height:23rem;
    
    /* width: 21rem; */
    /* margin-top: 5rem; */
    margin: 0 2rem 0 2rem;
    margin-right: 0;
  }
`;

export const Centro = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 18rem;
  gap: 0.5rem;
  padding-left: 21%;
  
  @media (max-width: 865px) {
  flex-direction: column;
  height: 50rem;
  } 
`;

export const Description = styled.div`
  width: 35rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: justify;
  line-height: calc(var(--size) * 3.5);
  font-family: var(--familyTitle);
  font-weight: bold;
  font-size: calc(var(--size) * 1.6);
  color: var(--darkBlue);
  border-radius: 3rem;
  background-color: var(--softGray);
  padding: 2rem;
  height: 15rem;
  box-shadow: 0.3rem 0.3rem 0.3rem var(--darkBlue);
  margin: 1rem;
  
  :hover {
    /* color: var(--purple); */
    background-color: var(--hardYellow);
    transform: scale(0.95);
  }

  @media (max-width: 1095px) {
    width: 26rem;
    /* font-size: calc(var(--size) * 1.4); */
  }

  @media (max-width: 850px) {
    width: 40rem;
    margin: 0.5rem;
  }
`;

export const Icon = styled.img`
  width: 6rem;
  margin: 1rem;
`;

export const Description2 = styled.div`
  width: 35rem;
  max-width: 118rem;
  /* margin: 0 auto 2rem auto; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* flex-wrap: nowrap; */
  text-align: justify;
  line-height: calc(var(--size) * 3.5);
  font-family: var(--familyTitle);
  font-weight: bold;
  font-size: calc(var(--size) * 1.6);
  color: var(--secondary);
  /* border: 3px solid; */
  border-radius: 3rem;
  background-color: var(--softBlue);
  padding: 3rem;
  height: 15rem;
  box-shadow: 0.3rem 0.3rem 0.3rem var(--darkBlue);

  :hover {
    transform: scale(0.95);
    /* color: var(--purple); */
    /* font-weight: bold; */
    background-color: var(--hardYellow);
  }

  @media (max-width: 1095px) {
    width: 26rem;
  }
  
  @media (max-width: 850px) {
    width: 40rem;
    margin: 0.5rem;
  }


`;

export const Link = styled.a`
  display: flex;
  transition: transform 0.3s;
  cursor: pointer;
  font-size: calc(var(--size) * 1.5);
  /* font: var(--body); */
  outline: none;
  text-decoration: none;
  color: var(--primary);  
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  margin: 1rem 0;

  > div {
    width: 100%;
    max-width: 10rem;
  }
`;

export const SearchMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.8rem;
  padding: 0.8rem;
  background-color: var(--darkBlue);
  border-radius: 0.8rem;
  font: var(--body);
  color: var(--secondary);
  margin-bottom: 1rem;

  > p {
    text-align: center;
  }
`;


// export const Search = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   justify-content: center;
//   flex-wrap: nowrap;
//   margin-top: -4rem;
//   position: relative;
// `;

// export const DivStayTunned = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   justify-content: flex-start;
//   flex-wrap: nowrap;
//   margin: auto;
//   max-width: 118rem;
//   width: 100%;
//   margin-top: 2rem;

//   /* @media (max-width: 1215px){
//     margin: 2rem auto auto 2rem;
//   } */
// `;

// export const TitleTunned = styled.div`
//   display: flex;
//   font-size: calc(var(--size) * 2);
//   color: var(--purple);
//   font: var(--title);
// `;

// export const IconWirelles = styled.img`
//   /* display: flex; */
// `;



// export const Feed = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   flex-wrap: nowrap;
//   background-color: var(--gray);
//   width: 100%;
//   padding: 2rem 0 2rem 0;
  
//   @media (max-width: 1215px) {
//     padding: 2rem;
//   }
// `;

// export const News = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   flex-wrap: nowrap;
//   width: 100%;
//   background-color: var(--gray);
//   gap: 1.5rem;
// `;

